import apiClient from "../config/apiClient";
import { API_ENDPOINTS } from "../config/endpoints";
import { handleApiError } from "../config/errorHandler";

/**
 * Fetch items for a specific restaurant branch
 * @param {number} restaurantId - The restaurant ID
 * @param {number} branchId - The branch ID
 * @param {number} [categoryId] - The category ID (optional)
 * @param {string} language - Language preference
 * @param {number} currencyId - The currency ID
 * @returns {Promise<Object>} - Response data from the API
 */
export const getItems = async (
  restaurantId,
  branchId,
  categoryId = "",
) => {
  try {
    const response = await apiClient.get(
      `${API_ENDPOINTS.RESTAURANT}/${restaurantId}/branch/${branchId}/items?category_id=${categoryId}&language=en&currency_id=3`
    );
    return response.data.data;
  } catch (error) {
    handleApiError(error);
    throw error;
  }
};
